import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class EditBinDialogStyle extends CommonComponentStyle {
  TitleWrapper = styled.div`
    padding: 0 16px;
    background: ${this.colors.PRIMARY_BLUE};
  `;

  Title = styled.p`
    font-weight: 700;
    font-size: 16px;
    color: #fff;
  `;

  Text = styled.p`
    font-size: 14px;
  `;

  FieldRowWrapper = styled(Grid)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
  `;

  FooterWrapper = styled.div`
    display: flex;
    margin: 0px 8px;
    justify-content: center;
    gap: 16px;
    padding: 16px;
  `;

  InputWrapper = styled(Grid)`
    margin: 8px 0;
    width: 250px;
  `;
}

export default new EditBinDialogStyle();
